import GfProofOfDeliveries from '@/gf/components/ProofOfDeliveries'
import { useRemoveProofOfDeliveriesMutation } from '@/suppliers/_gen/gql'
import useGqlClient from '@/suppliers/hooks/useGqlClient'
import { useOrderContext } from './context'

const ProofOfDeliveries = () => {
  const { storeOrderId, storeOrder, refetch } = useOrderContext()
  const [removePods] = useRemoveProofOfDeliveriesMutation({ client: useGqlClient() })

  if (storeOrder.proofOfDeliveries.length === 0) return null

  const remove = async (pod: string) => {
    await removePods({ variables: { storeOrderId, urls: [pod] } })
    refetch()
  }

  return (
    <GfProofOfDeliveries
      uploadPath={`/orders/${storeOrderId}/upload-proof-of-delivery`}
      proofOfDeliveries={storeOrder.proofOfDeliveries}
      remove={remove}
    />
  )
}

export default ProofOfDeliveries
